import React from "react"
import { Link } from "react-router-dom"
import { buildModuleVOOverviewUrl } from "../moduleVoNavigation"
import { useModuleVOConfigParams } from "../hooks/useModuleVOConfigParams"
import VariableFees from "../components/VariableFees"

export default function ConfigVariableFees() {
    const { scope } = useModuleVOConfigParams()

    return (
        <div className="container-fluid mb-2">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Nouvelle config — Frais variables</h4>
                <Link to={buildModuleVOOverviewUrl('variableFees')} className="btn btn-outline-secondary btn-sm">
                    <i className="fa fa-arrow-left tw-mr-2"></i>
                    Retour
                </Link>
            </div>

            <VariableFees mode="config" scope={scope} />
        </div>
    )
}
